import React from 'react';
import { motion } from "framer-motion";
import AboutForHero from '../About/AboutForHero';
import Highlight from './Highlight';
import HeroLayout from './HeroLayout';
import CTA from './CTA';

const Hero = () => {

  return (
    <>
      <HeroLayout />
      <AboutForHero />
      <Highlight />
      <CTA/>
    </>
  );
};

export default Hero;